"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.objekt_fse = void 0;
const leaflet_1 = __importDefault(require("leaflet"));
exports.objekt_fse = leaflet_1.default.icon({
    iconUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAZCAIAAACpVwlNAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAAOwAAADsABataJCQAAABh0RVh0U29mdHdhcmUAcGFpbnQubmV0IDQuMS42/U4J6AAAAU1JREFUSEvtkSGrg2AUhg02f4JhIPgXRLDI8AdcWVxbckVkwZs1iajZIgumgdVqlSXjLZaFBZOrW9k9er6JVy/cCTNc2IPgOe85POj3UXdqrqd9zcFbPeCtHtBX3263j5+oqoqjOI41TYPWsqy6rjFcrVZk74Ft2zhqGKih3W63nz0gdxwH8v1+fzgcYMpx3OVygZzneVmWyV5LFEWtqWWsPp1O2HZIkmQYBmnud1CHYQgFqF3XxfAXnlHrur5cLtM0vV6vJGqZrO5zPB5xtNvtFosFJIIgJEmCIahxrSPPcxw1QD9QZ1n29QDzjqIofN+HHTxTUOOtduAaYaweHMj5fIbvxXtDPM9br9dQvOCs4Ro3m01VVVCXZcmybBAEUL9ADX+qKApN0zBlGMY0TczHZy2KIo4aoO/UfwKfTKpnmKSexls94F+r53go6hv+0RFerAtsHAAAAABJRU5ErkJggg==",
    iconSize: [30, 25],
});
